export default "__VITE_ASSET__C2pjNG1s__"